<template>
  <rich-button @click="commands.italic" v-bind:isActive="isActive.italic()" v-bind:icon="'italic'" />
</template>

<script>
  import ItalicButton from './ItalicButton.ts'
  export default ItalicButton
</script>
